import { SxObjType } from "lib/theme/types/SxObjType.type";
import theme from "lib/theme/theme";

const sxStyles = () => {
  return {
    checkboxContainer: {
      marginBottom: theme.spacing(2),
    },
    checkBoxLabel: {
      fontWeight: theme.typography.fontWeightBold,
    },
  } satisfies SxObjType;
};
export { sxStyles };
